<script setup>
import { Link } from "@inertiajs/inertia-vue3";
import { computed } from "vue";

const props = defineProps({
  href: String,
});

// If href is a valid prop turns component to Link otherwise a button
const type = computed(() => {
  if (props.href) {
    return Link;
  } else {
    return "button";
  }
});
</script>

<template>
  <component
    :is="type"
    :href="href"
    class="
      inline-block
      text-oteo-300
      font-semibold
      py-2
      px-5
      border border-oteo-300
      rounded
      hover:bg-oteo-100
    "
  >
    <slot />
  </component>
</template>
